import { ReleaseNoteByod } from '@src/main/modules/parameters/domain/release-notes-byod/release-note-byod.interface';

export interface ReleaseNoteByodEntity {
  releaseNoteByodId?: string;
  description: string;
  version: string;
}

export function toReleaseNoteByod(entity: ReleaseNoteByodEntity): ReleaseNoteByod {
  return {
    releaseNoteByodId: entity.releaseNoteByodId,
    description: entity.description,
    version: entity.version,
  };
}

export function fromReleaseNoteByod(model: ReleaseNoteByod): ReleaseNoteByodEntity {
  return {
    releaseNoteByodId: model.releaseNoteByodId,
    description: model.description,
    version: model.version,
  };
}
